import Vue from 'vue'
import App from './App.vue'
import lsWatcher from 'vue-storage-watcher'

Vue.config.productionTip = false
Vue.use(lsWatcher, { prefix: 'ijch_' });

new Vue({
  render: h => h(App),
}).$mount('#app')
